var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.1,399.6l-27.2-30.8l-22.5,19.9l48.7,55.1l78.9-81.7l-21.6-20.8L354.1,399.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.5,265.3c-2.7,0-5.4,0.1-8.1,0.3l-8.7-148.9h-71V87.8c0-48.4-39.4-87.8-87.8-87.8s-87.8,39.4-87.8,87.8 v28.9h-71L19.3,386.6c-1.2,21,6.1,41,20.5,56.3s34,23.7,55,23.7H274c22.6,27.7,57,45.3,95.5,45.3c68,0,123.3-55.3,123.3-123.3 C492.8,320.7,437.5,265.3,369.5,265.3z M136.1,87.8c0-31.9,25.9-57.8,57.8-57.8s57.8,25.9,57.8,57.8v28.9H136.1V87.8z M94.9,436.7 c-12.7,0-24.5-5.1-33.2-14.3s-13.1-21.3-12.4-34l14.1-241.6h42.7v37.6h30v-37.6h115.5v37.6h30v-37.6h42.7l7.3,124.6 c-49.5,16-85.5,62.6-85.5,117.4c0,17,3.5,33.2,9.7,48L94.9,436.7L94.9,436.7z M369.5,482c-51.5,0-93.3-41.9-93.3-93.3 c0-51.5,41.9-93.3,93.3-93.3s93.3,41.9,93.3,93.3C462.8,440.1,420.9,482,369.5,482z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.d9c7d393c8ade37b1eb4e7fe4c4ea6fd.svg";
export { ForwardRef as ReactComponent };